module.exports = __webpack_public_path__ + "assets/regou.53cd4b2d.svg";